// Module
var code = "<svg width=\"18\" height=\"19\" viewBox=\"0 0 18 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M1 0.5V18.5L17 9.5L1 0.5Z\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> </svg> ";
// Exports
module.exports = code;